import React from "react";

import { Tooltip } from "~/components/tooltip";
import { TooltipContent } from "~/components/tooltip/content";
import { TooltipTrigger } from "~/components/tooltip/trigger";

export const NotAvailable: React.FC = () => (
	<Tooltip>
		<TooltipTrigger>
			<span className="text-core-text-neutral-tertiary tracking-widest">n/a</span>
		</TooltipTrigger>
		<TooltipContent>Not available</TooltipContent>
	</Tooltip>
);
